import { useTranscricao } from '../../context/TranscricaoContext';
import './TranscriptionDebug.css';

export default function TranscriptionDebug() {
  const { transcriptionHistory } = useTranscricao();

  // Pega as últimas 5 transcrições e inverte para mostrar a mais recente no topo
  const recentTranscriptions = transcriptionHistory.slice(-5).reverse();

  const getConfidenceColor = (confidence) => {
    if (confidence >= 0.9) return '#4caf50'; // Verde
    if (confidence >= 0.7) return '#ff9800'; // Laranja
    return '#f44336'; // Vermelho
  };

  return (
    <div className="transcription-debug">
      <div className="transcription-debug-header">
        📝 Transcrição Recente ({transcriptionHistory.length} total)
      </div>

      <div className="transcription-list">
        {recentTranscriptions.length === 0 ? (
          <div className="transcription-empty">
            Nenhuma transcrição ainda...
          </div>
        ) : (
          recentTranscriptions.map((transcript, index) => {
            // Calcula o índice real (mais recente primeiro)
            const realIndex = transcriptionHistory.length - index;
            return (
              <div key={transcript.id || index} className="transcription-item">
                <span className="transcription-index">
                  #{realIndex}
                </span>
                <span className="transcription-text">
                  {transcript.text}
                </span>
                <span
                  className="transcription-confidence"
                  style={{ color: getConfidenceColor(transcript.confidence) }}
                >
                  {(transcript.confidence * 100).toFixed(0)}%
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

